// ro-input-char-limiter.js
;(() => {
    const limiters = document.querySelectorAll('.ro-input-char-limiter')

    limiters.forEach(limiter => {
        const limit = parseInt(limiter.dataset.roCharLimit) || 0
        const input = limiter.querySelector('.ro-input-char-limiter__input')
        const counter = limiter.querySelector('.ro-input-char-limiter__counter')

        if (!input) {
            console.error('Cannot find input for ', limiter)
            return
        }

        if (!counter) {
            console.error('Cannot find counter for ', limiter)
            return
        }
        
        let remainingChars = limit
        let prevValue = input.value
        
        init()
    
        function init() {
            updateCounter()

            input.addEventListener('input', event => {
                const value = event.target.value

                const deltaRemaining = limit - value.length
                if (deltaRemaining < 0) {
                    input.value = value.slice(0, limit)
                }

                prevValue = value
                remainingChars = limit - input.value.length

                updateCounter()
            })
        }

        function updateCounter() {
            counter.innerHTML = remainingChars
        }
    })

})();